export enum AtsFileTypes {
	PNG = 'image/png',
	JPEG = 'image/jpeg',
	ZIP = 'application/zip',
	X_ZIP_COMPRESSED = 'application/x-zip-compressed',
	X_COMPRESSED = 'application/x-compressed',
	X_ZIP = 'multipart/x-zip',
	DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	CSV = 'text/csv',
	FIREFOX_EXCEL = 'application/vnd.ms-excel',
}
